import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'
import { ClientBehaviours } from '../../utils'

import { login } from '../../../graphql/Mutation/Account/Login.graphql'

export const mockSuccessResponse = {
  error: null,
  fieldErrors: null,
  token: '7880313f-a2a5-49eb-8c5e-3e9f73fd3741',
  customer: {
    title: 'Mr',
    fullName: 'Neil Armstrong',
    firstName: 'Neil',
    lastName: 'Armstrong',
    email: 'neil.armstrong@nasa.gov',
    __typename: 'Customer',
  },
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}

export const mockFailResponse = {
  error: 'ACCOUNT_NOT_FOUND',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}

export const mockInvalidTokenResponse = {
  error: 'INVALID_TOKEN',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockExpiredTokenResponse = {
  error: 'EXPIRED_TOKEN',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockAlreadyUsedTokenResponse = {
  error: 'ALREADY_USED_TOKEN',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockEmailVerificationSentResponse = {
  error: 'EMAIL_VERIFICATION_SENT',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockInvalidPasswordResponse = {
  error: 'INVALID_PASSWORD',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockInvalidDataResponse = {
  error: 'INVALID_DATA',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockFailedLoginResponse = {
  error: 'FAILED_LOGIN',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockAccountLockedResponse = {
  error: 'ACCOUNT_LOCKED',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockAccountVerificationResponse = {
  error: 'ACCOUNT_VERIFICATION',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}
export const mockPendingActionResponse = {
  error: 'PENDING_ACTION',
  fieldErrors: null,
  token: null,
  customer: null,
  newCustomer: false,
  __typename: 'AuthenticationResponse',
}

export const Login = (
  client: ApolloClient<NormalizedCacheObject>,
  { behaviours }: { behaviours: ClientBehaviours },
) => async (_, args, context?) => {
  if (behaviours.override) {
    if (args.input.username.indexOf('invalidToken') !== -1) {
      return mockInvalidTokenResponse
    }
    if (args.input.username.indexOf('expiredToken') !== -1) {
      return mockExpiredTokenResponse
    }
    if (args.input.username.indexOf('alreadyUsedToken') !== -1) {
      return mockAlreadyUsedTokenResponse
    }
    if (args.input.username.indexOf('accountLocked') !== -1) {
      return mockAccountLockedResponse
    }
    if (args.input.username.indexOf('failedLogin') !== -1) {
      return mockFailedLoginResponse
    }
    if (args.input.username.indexOf('invalidData') !== -1) {
      return mockInvalidDataResponse
    }
    if (args.input.username.indexOf('emailVerificationSent') !== -1) {
      return mockEmailVerificationSentResponse
    }
    if (args.input.username.indexOf('pendingAction') !== -1) {
      return mockPendingActionResponse
    }
    if (args.input.username.indexOf('invalidPassword') !== -1) {
      return mockInvalidPasswordResponse
    }

    return mockSuccessResponse
  }
  const mutateArgs =
    context && context.headers['X-Captcha-Type']
      ? {
          context,
          variables: args,
          mutation: login,
        }
      : { variables: args, mutation: login }

  const { data, extensions } = await client.mutate(mutateArgs)

  return {
    ...data['login'],
    extensions,
    __typename: 'AuthenticationResponse',
  }
}
